var authStatusConstants = {
  CANCELLED: 'CANCELLED',
  COMPLETE: 'COMPLETE',
  FAIL: 'FAIL'
};
export { authStatusConstants as default };